import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { Wrapper, Image } from '@farewill/ui'
import { COLOR, GTR } from '@farewill/ui/tokens'
import { screenMin } from '@farewill/ui/helpers/responsive'

import ExternalLink from 'components/ExternalLink'
import TelephoneNumber from 'components/TelephoneNumber'
import { PRODUCTS, PRODUCTS_MAP } from 'lib/products/constants'

/**
 * The `FAREWILL_URL` is hardcoded because the `ROOT_URL` config variable may
 * be set to the branded subdomain URL, and we explicitly want to link to the
 * non-cobranded Farewill home page.
 */
const FAREWILL_URL = 'https://farewill.com'

const StyledWrapper = styled(Wrapper)`
  height: 64px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${screenMin.l`
    border-bottom: solid 1px ${COLOR.GREY.LIGHT};
  `}
`

const StyledLockup = styled(Wrapper)`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 12px;
`

const StyledTelephoneNumber = styled(TelephoneNumber)`
  align-self: center;
  display: none;
  margin-right: ${GTR.XXL};

  ${screenMin.m`
    display: block;
  `}
`

const StyledCrukLogo = styled(Image)`
  display: block;
  height: 100%;
  max-width: 124px;
`

const StyledFarewillLink = styled(Link)`
  display: block;
  height: 100%;
`

const StyledFarewillLogo = styled(Image)`
  display: block;
  max-width: 154px;
  position: relative;
  height: calc(100% + 1px);
  top: -1px;
  ${screenMin.m`
    max-width: 192px;
  `}
`

const Header = (): React.ReactElement => (
  <StyledWrapper tag="header" background={COLOR.WHITE}>
    <StyledLockup>
      <StyledFarewillLink to={FAREWILL_URL}>
        <StyledFarewillLogo
          path="internal-logos/logo-farewill-background-fill-mobile"
          pathFromM="internal-logos/logo-farewill-background-fill"
          width={154 * 2}
          widthFromM={192 * 2}
          alt="Farewill"
        />
      </StyledFarewillLink>
      <ExternalLink href="https://www.cancerresearchuk.org/get-involved/leave-a-legacy-gift-in-your-will/will-writing-service">
        <StyledCrukLogo
          path="com-assets/bespoke-journey-cruk/logo"
          ext="png"
          width={124 * 2}
          alt="Cancer Research UK"
        />
      </ExternalLink>
    </StyledLockup>

    <StyledTelephoneNumber
      telephoneNumber={PRODUCTS_MAP[PRODUCTS.WILLS].telephoneNumber}
    />
  </StyledWrapper>
)

export default Header
